import { render, staticRenderFns } from "./ManageCardActions.vue?vue&type=template&id=2a5887bc&scoped=true&"
import script from "./ManageCardActions.vue?vue&type=script&lang=js&"
export * from "./ManageCardActions.vue?vue&type=script&lang=js&"
import style0 from "./ManageCardActions.vue?vue&type=style&index=0&id=2a5887bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5887bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VRow})
